import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  DistributionDetailModel,
  DistributionModel,
} from '../../models/distribution.model';

export interface DistributionFilters {
  month?: string;
  status?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  private readonly baseUrl = `${environment.apiUrl}/api/distributions`;

  constructor(private readonly http: HttpClient) {}

  /**
   * /api/distributions returns distribution RUNS (startDate, periodLabel, totalToDistribute…);
   * this page read periodStart/grossCollected, so every filter/sort hit undefined and the list
   * stayed empty (QA 2026-10-04). Map the run shape here.
   */
  getDistributions(filters?: DistributionFilters): Observable<DistributionModel[]> {
    return this.http.get<any[]>(this.baseUrl).pipe(map(runs => (runs ?? []).map(r => ({
      id: r.id,
      periodStart: r.startDate ?? '',
      periodEnd: r.endDate ?? '',
      grossCollected: r.totalToDistribute ?? 0,
      status: r.status,
      createdAt: r.generatedAt,
      label: r.periodLabel ?? '',
    }))));
  }

  getDistributionDetail(id: number): Observable<DistributionDetailModel> {
    return this.http.get<DistributionDetailModel>(`${this.baseUrl}/${id}`);
  }

  approveDistribution(id: number): Observable<DistributionModel> {
    return this.http.put<DistributionModel>(`${this.baseUrl}/${id}/approve`, {});
  }

  rerunDistribution(id: number): Observable<DistributionModel> {
    return this.http.post<DistributionModel>(`${this.baseUrl}/${id}/rerun`, {});
  }
}
